import { useState, useEffect } from "react";
import Loader from "../../components/Loader/Loader";
import { getCenter } from "../../api/centerAPI";
import {
    Box,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { dayArr } from "../../constants/common";
import { CenterData } from "../../types/api/center";

const tableHeaders = ["День недели", "С", "По"];

const ContactsPage = () => {
    const [loading, setLoading] = useState(true);
    const [centerInfo, setCenterInfo] = useState<CenterData>();

    useEffect(() => {
        const centerId = localStorage.getItem("current_center_id") || "";
        setLoading(true);
        getCenter(Number(centerId), (centerInfo: any) => {
            setCenterInfo(centerInfo.data);
            setLoading(false);
        });
    }, []);
    return (
        <div className="container">
            <div className={"pageHeader"}>Контакты</div>
            <Paper>
                {loading ? (
                    <Loader />
                ) : (
                    <Stack gap={2} sx={{ p: 4 }}>
                        <Typography variant="body1" textAlign={"start"}>
                            Адрес:{" "}
                            <b>
                                {centerInfo?.address?.city}, {centerInfo?.address?.street},{" "}
                                {centerInfo?.address?.building}
                            </b>
                        </Typography>
                        <Typography variant="body1" textAlign={"start"}>
                            Номер телефона: <b>{centerInfo?.phone || "не указан"}</b>
                        </Typography>
                        <Typography variant="body1" textAlign={"start"}>
                            Электронная почта: <b>{centerInfo?.email || "не указана"}</b>
                        </Typography>
                        <Typography variant="body1" textAlign={"start"}>
                            График работы:
                        </Typography>
                        <Box>
                            {centerInfo?.schedule?.length ? (
                                <TableContainer sx={{ marginBottom: "80px" }}>
                                    <Table aria-label="centers table" sx={{ "& td": { border: "none" } }}>
                                        <TableHead sx={{ "& th": { fontSize: "16px", fontWeight: 400 } }}>
                                            <TableRow>
                                                {tableHeaders.map((header, index) => (
                                                    <TableCell key={index} align={index !== 0 ? "center" : "left"}>
                                                        {header}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {centerInfo?.schedule?.map(day => (
                                                <TableRow key={day.id} sx={{ border: 0 }}>
                                                    <TableCell align="center">{dayArr[day.day - 1]}</TableCell>
                                                    <TableCell align="center">{day.from}</TableCell>
                                                    <TableCell align="center">{day.to}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                "Н/Д"
                            )}
                        </Box>
                    </Stack>
                )}
            </Paper>
        </div>
    );
};

export default ContactsPage;
